import { TagTypes } from 'enums/tagTypes';
import { apiSlice } from 'store/api/apiSlice';

import { Tag } from './patientTags.types';

export const patientTagsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    editPatientTags: builder.mutation<{ message: string }, { body: string[]; patientId: string }>({
      invalidatesTags: () => [{ id: 'LIST', type: 'Tags' }],
      query: ({ body, patientId }) => ({
        body,
        method: 'PUT',
        url: `/patients/${patientId}/tags`
      })
    }),
    getTags: builder.query<{ data: Tag[]; totalCount: number }, { patientId: string }>({
      keepUnusedDataFor: 0,
      providesTags: () => [{ id: 'LIST', type: 'Tags' }],
      query: ({ patientId }) => `/patients/${patientId}/tags`
    }),
    getTagsList: builder.query<{ data: Tag[]; message: string }, { tagTypes: TagTypes[] }>({
      keepUnusedDataFor: 300, // keep tags cache for 5 min
      providesTags: () => [{ id: 'LIST', type: 'Tags' }],
      query: ({ tagTypes }) => {
        return {
          params: {
            types: tagTypes.join(',')
          },
          url: '/user-tags'
        };
      }
    })
  })
});

export const {
  useEditPatientTagsMutation,
  useGetTagsListQuery,
  useGetTagsQuery,
  useLazyGetTagsQuery
} = patientTagsApi;
